export default "__VITE_ASSET__Bb2ARpFT__"